import React from "react";
import {
  EvaluationCard,
  SummaryMetricCard,
  EvaluationFooter,
} from "./components";
import {
  AccuracyProgressBar,
  FluencyRatingBar,
  NotesToggleInput,
} from "./EvaluationComponents";

const ResultsStep = ({
  totalWords,
  incorrectWords,
  accuracyPercent,
  activeCategory,
  fluencyScore,
  notes,
  setNotes,
  onBack,
  onNext,
  isSaving,
}) => {
  return (
    <div
      className="mx-auto"
      style={{
        maxWidth: "860px",
        width: "100%",
        direction: "rtl",
        paddingBottom: "100px",
      }}
    >
      <EvaluationCard className="mb-4">
        <h4
          className="text-center mb-4 fw-bold text-dark"
          style={{ fontSize: "22px" }}
        >
          تلخيص تقييم القراءة
        </h4>

        <div className="row g-3 mb-4">
          <div className="col-6">
            <SummaryMetricCard
              title="عدد الكلمات الكلي"
              value={`${totalWords} كلمة`}
              fontSize="24px"
            />
          </div>
          <div className="col-6">
            <SummaryMetricCard
              title="عدد الكلمات الخاطئة"
              value={`${incorrectWords} كلمة`}
              fontSize="24px"
            />
          </div>
        </div>

        <AccuracyProgressBar
          accuracyPercent={accuracyPercent}
          activeCategory={activeCategory}
        />

        <FluencyRatingBar fluencyScore={fluencyScore} />

        <div
          className="p-4 mb-4 text-end rounded-3"
          style={{
            border: "1px solid #bae6fd",
            backgroundColor: "#f0f9ff",
            color: "#0369a1",
          }}
        >
          <div className="fw-bold mb-2 text-dark" style={{ fontSize: "16px" }}>
            {activeCategory.title}
          </div>
          <div
            style={{
              fontSize: "14px",
              lineHeight: "1.6",
              color: "#334155",
            }}
          >
            {activeCategory.description}
          </div>
        </div>

        <NotesToggleInput notes={notes} setNotes={setNotes} />
      </EvaluationCard>

      <EvaluationFooter
        primaryText="الانتقال الى اسئلة الفهم"
        secondaryText="الرجوع"
        onPrimaryClick={onNext}
        onSecondaryClick={onBack}
        showSecondary={true}
        isSaving={isSaving}
      />
    </div>
  );
};

export default ResultsStep;
